import type { User } from '@/types/user';
import { getIntegrationManager, bootstrapIntegrations } from './bootstrap';

export { bootstrapIntegrations, getIntegrationManager };
export { showIntercom } from './providers/intercom';
export type { Integration, IntegrationManager } from './types';
export type { MixpanelConfig } from './providers/mixpanel';
export type { IntercomConfig } from './providers/intercom';
export { createIntegrationManager } from './core';
export { createMixpanelIntegration } from './providers/mixpanel';
export { createIntercomIntegration } from './providers/intercom';
export { createSentryIntegration } from './providers/sentry';

export const identifyUser = (user: User): void => {
  getIntegrationManager().identify(user);
};

export const resetIntegrations = (): void => {
  getIntegrationManager().reset();
};

export const trackEvent = (
  event: string,
  props?: Record<string, any>
): void => {
  getIntegrationManager().track(event, props);
};
